<template>
  <span
    class="steps-item"
    :class="{'steps-item--active': isActive}"
  >
    <span class="steps-item__number" />
    <span class="steps-item__text">{{ text }}</span>
  </span>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    text: {
      type: [String,Number],
      default: null
    }
  }
};
</script>

<style lang="scss">
  @import "../../styles/shared/shared";
  $steps-item-number-bg: $pigeon;
  $steps-item-number-bg-active: $tangerine;
  $steps-item-number-size: 30px;
  $steps-item-line-height: 2px;
  .steps-item {
    $this: &;
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    flex: 1 1 auto;
    padding-left: 5px;
    padding-right: 5px;
    font-size: $font-size-sm;
    @include minpoint(tablet) {
      font-size: $font-size-base;
      padding-left: 10px;
      padding-right: 10px;
    }
    &:before {
      position: absolute;
      z-index: -1;
      left: 0;
      width: 100%;
      height: $steps-item-line-height;
      content: '';
      background-color: $steps-item-number-bg;
      top: ($steps-item-number-size / 2) - ($steps-item-line-height / 2);
    }
    &:first-of-type,
    &:last-of-type {
      &:before {
        width: 50%;
      }
    }
    &:first-of-type:before {
      left: 50%;
    }
    &:last-of-type:before{
      right: 50%;
    }
    &__number {
      height: $steps-item-number-size;
      width: $steps-item-number-size;
      line-height: $steps-item-number-size;
      color: $white;
      border-radius: 50%;
      margin-bottom: 5px;
      background-color: $steps-item-number-bg;
      &:before {
        counter-increment: steps;
        content: counter(steps);
      }
    }
    &--active {
      font-weight: bold;
      #{$this}__number {
        background-color: $steps-item-number-bg-active;
      }
    }
  }
</style>
